import React from "react";

const AboutCard = ({ bgImage, logo, heading, content }) => {
  return (
    <div className="col-span-1 relative flex flex-col items-center">
      {/* Background Image */}
      <div className="relative w-full">
        <img
          src={bgImage}
          className="w-full h-[300px] md:h-[350px] lg:h-[400px] object-cover"
          alt="Service Background"
        />

        {/* Empty Space Behind the Card */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 w-[90%] md:w-[90%] lg:w-[90%] min-h-[200px] max-h-[300px] text-center flex flex-col justify-center items-center gap-3 px-4 md:px-6 py-6 shadow-lg border border-gray-300 rounded-lg bg-white z-10">
          {/* Logo */}
          <div className="w-[50px] md:w-[60px] h-[50px] md:h-[60px] p-2 md:p-3 rounded-full absolute -top-[25px] md:-top-[30px] bg-[#75000E] flex justify-center items-center z-20">
            <img
              src={logo}
              className="w-[70%] h-[70%] object-contain"
              alt="Service Logo"
            />
          </div>

          {/* Heading */}
          <h2 className="font-bold text-sm sm:text-sm md:text-md lg:text-lg mt-[50px] break-words px-4">
            {heading}
          </h2>

          {/* Content */}
          <p className="text-xs sm:text-sm md:text-md lg:text-md md:px-4 leading-5 md:leading-6 break-words mt-2">
            {content}
          </p>
        </div>
      </div>

      {/* Invisible spacer behind the card */}
      <div className="h-[150px] md:h-[150px] lg:h-[150px]"></div>
    </div>
  );
};

export default AboutCard;
